import { render, staticRenderFns } from "./add_awards.vue?vue&type=template&id=5e3af30f"
import script from "./add_awards.vue?vue&type=script&lang=js"
export * from "./add_awards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports